import { render } from "./TextInModal.vue?vue&type=template&id=7ae5d3a2&scoped=true"
import script from "./TextInModal.vue?vue&type=script&lang=js"
export * from "./TextInModal.vue?vue&type=script&lang=js"

import "./TextInModal.vue?vue&type=style&index=0&id=7ae5d3a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae5d3a2"]])

export default __exports__